import { render } from "./VariableSearchResult.vue?vue&type=template&id=1138c1f4&scoped=true"
import script from "./VariableSearchResult.vue?vue&type=script&lang=js"
export * from "./VariableSearchResult.vue?vue&type=script&lang=js"

import "./VariableSearchResult.vue?vue&type=style&index=0&id=1138c1f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1138c1f4"]])

export default __exports__